
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IItem } from "@tylertech/tyler-api-types";

/**
 * ItemService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetItem(pItemId: string): Promise<IItem> {
        return this.$apiService.sendAuth("IItemService/GetItem", pItemId);
    }
    GetNextItemNumber(): Promise<string> {
        return this.$apiService.sendAuth("IItemService/GetNextItemNumber");
    }
    SaveItem(pItem: IItem): Promise<IItem> {
        return this.$apiService.sendAuth("IItemService/SaveItem", pItem);
    }
}
